export enum FormulaType
{
    RegularFormula = 'RegularFormula',
    LazyFormula = 'LazyFormula',
    LiveFormula = 'LiveFormula',
}
